// Pure factory for the drawer's user actions. Each resets the chain so a
// cluster/pipeline/mode change never leaves stale stage output behind.
export default function buildDrawerActions({ setMode, setClusterId, pipelineSelection, pipelineData, chainState }) {
  const onSelectPipeline = pipelineId => {
    pipelineSelection.onSelectPipeline(pipelineId);
    chainState.resetChain();
    const pipeline = pipelineSelection.pipelines.find(candidate => candidate.id === pipelineId);
    if (pipeline) {
      pipelineData.loadPipelineData({ pipeline });
    } else {
      pipelineData.clearPipelineData();
    }
  };

  const onClusterChange = newClusterId => {
    setClusterId(newClusterId);
    pipelineSelection.clearSelection();
    pipelineData.clearPipelineData();
    chainState.resetChain();
  };

  const onChangeMode = newMode => {
    setMode(newMode);
    chainState.resetChain();
  };

  return { onSelectPipeline, onClusterChange, onChangeMode };
}
